export default "__VITE_ASSET__f1890e6f__"